import { render, staticRenderFns } from "./CompanyOffers.vue?vue&type=template&id=089d7f9a&scoped=true"
import script from "./CompanyOffers.vue?vue&type=script&lang=js"
export * from "./CompanyOffers.vue?vue&type=script&lang=js"
import style0 from "./CompanyOffers.vue?vue&type=style&index=0&id=089d7f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089d7f9a",
  null
  
)

export default component.exports